<div class="container-sm">
  <div class="card-list">
    @for (contact of data.contacts; track contact.id) {
      <mb-contact-person-card
        class="column-card"
        [fullname]="contact.fullname"
        [position]="contact.position"
        [email]="contact.email"
        [phone]="contact.phone"
        [media]="contact.image"
        [initials]="contact.initials"
        [hideMedia]="false"
      ></mb-contact-person-card>
    }
  </div>
</div>
